export default __webpack_public_path__ + "a6accd45ecdf26be40dc3be88223c9e3.png";